import { useLingui } from '@lingui/react';
import { Box, Card, Image, Text, rem, useMatches } from '@mantine/core';
export const WithdrawNotification = () => {
  const {
    i18n
  } = useLingui();
  const bottom = useMatches({
    base: rem(10),
    sm: rem(-20),
    lg: rem(-32)
  });
  const right = useMatches({
    base: rem(10),
    sm: rem(10),
    lg: rem(43)
  });
  return <Card radius={5} p={{
    base: 10,
    sm: 20
  }} pos="relative" bg="var(--input-variant-color)" style={{
    overflow: 'visible'
  }}>
      <Image src="/assets/wallet/notifi.svg" alt="decoration" pos="absolute" right={right} bottom={bottom} w={{
      base: 100,
      sm: 136,
      lg: 164
    }} h={{
      base: 100,
      sm: 136,
      lg: 160
    }} />
      <Box w={{
      base: 273,
      sm: 500
    }} style={{
      wordBreak: 'break-word'
    }}>
        <Text fz={12} c="var(--text-dark)">
          {i18n._('*You will receive the specified Tether amount on your withdrawal address.')}
        </Text>
        <Text fz={12} c="var(--text-dark)">
          {i18n._('*The value subtracted from your balance may vary between now and the time we process your withdrawal.')}
        </Text>
      </Box>
    </Card>;
};